module.exports = __webpack_public_path__ + "img/24.d34861a3.png";